import { ShoppingBasket, Users, Warehouse, type LucideIcon } from "lucide-react";

import { type TileEntityType } from "./types";

interface TileEntityConfig {
  /** i18n key resolving to the plural entity name. */
  labelKey: string;
  /**
   * Accessible name for the header link, since it reads "View" on screen.
   * Absent for entities with no list page, which show no header link.
   */
  viewAllAriaLabelKey?: string;
  /** Icon shown in the tile header badge. */
  icon: LucideIcon;
  /** Tailwind classes for the header icon badge. */
  badgeClassName: string;
}

export const TILE_ENTITY_CONFIG: Record<TileEntityType, TileEntityConfig> = {
  aggregator: {
    labelKey: "home.manager.overview.tiles.entities.aggregators",
    viewAllAriaLabelKey: "home.manager.overview.viewAllAggregators",
    icon: Warehouse,
    badgeClassName: "bg-ivory-100 text-ivory-600",
  },
  farmer: {
    labelKey: "home.manager.overview.tiles.entities.farmers",
    viewAllAriaLabelKey: "home.manager.overview.viewAllFarmers",
    icon: Users,
    badgeClassName: "bg-aqua-100 text-aqua-600",
  },
  buyer: {
    labelKey: "home.manager.overview.tiles.entities.buyers",
    viewAllAriaLabelKey: "home.manager.overview.viewAllBuyers",
    icon: ShoppingBasket,
    badgeClassName: "bg-green-100 text-green-600",
  },
};

/** Tile display order: Aggregators, then Farmers, then Buyers. */
export const TILE_ORDER: TileEntityType[] = ["aggregator", "farmer", "buyer"];
